<div class="page-loader-wrapper">
  <div class="loader">
    <div class="m-t-30">
      <img
        src="assets/images/logo-icon.svg"
        width="48"
        height="48"
        alt="Lucid"
      />
    </div>
    <p>duesPlus is loading...</p>
    <p style="color: white">Organization for organizations..</p>
  </div>
</div>
